import { SearchEntityType, GlobalSearchTab } from "@/models/search/Search";

interface EntityConfig {
  tab: GlobalSearchTab;
  title: string;
}

export const ENTITY_CONFIG: Record<SearchEntityType, EntityConfig> = {
  [SearchEntityType.Legislation]: {
    tab: GlobalSearchTab.Legislation,
    title: "Lovgivning",
  },
  [SearchEntityType.Workspace]: {
    tab: GlobalSearchTab.Workspace,
    title: "Workspaces",
  },
  [SearchEntityType.WorkspaceDocument]: {
    tab: GlobalSearchTab.WorkspaceDocuments,
    title: "Dokumenter",
  },
  [SearchEntityType.Chat]: {
    tab: GlobalSearchTab.Chat,
    title: "Chats",
  },
};

export const getTabFromEntityType = (
  entityType: SearchEntityType
): GlobalSearchTab => ENTITY_CONFIG[entityType]?.tab || GlobalSearchTab.All;

export const getCategoryTitle = (entityType: SearchEntityType): string =>
  ENTITY_CONFIG[entityType]?.title || entityType;
